export default __webpack_public_path__ + "media/images/contact-new-f411605ec463a8de10bf71834d0f7e6d.png";